import React from 'react';
import Logo from './Logo';

const TopBar = ({ action, dark }) => (
  <header
    className={`sticky top-0 z-20 backdrop-blur-xl ${
      dark ? 'border-b border-white/10 bg-[#0b0c10] shadow-[0_1px_0_rgba(0,0,0,0.4)]' : 'border-b border-black/5 bg-white/80'
    }`}
  >
    <div className="mx-auto flex h-12 max-w-5xl items-center justify-between px-6">
      <div className="flex items-center gap-2">
        <Logo size={28} className="mr-1 rounded-lg" />
        <span className={`text-[15px] font-semibold tracking-tight ${dark ? 'text-white' : 'text-ink'}`}>
          CTCV
        </span>
        <span className={`text-[15px] font-light ${dark ? 'text-white/20' : 'text-black/30'}`}>|</span>
        <span className={`text-[15px] ${dark ? 'text-white/50' : 'text-black/50'}`}>Hôpital Fann</span>
      </div>
      {action}
    </div>
  </header>
);

export default TopBar;
